<section class="settings-page">
  <header>
    <h1>Settings</h1>
    <p>Personnalise l’interface admin et les notifications.</p>
  </header>

  <p class="message" *ngIf="message">{{ message }}</p>

  <div class="cards">
    <article class="card">
      <h2>Thème</h2>
      <p>Choisis l’apparence de la plateforme.</p>
      <label>
        <span>Mode</span>
        <select [ngModel]="selectedTheme" (ngModelChange)="setTheme($event)">
          <option *ngFor="let theme of themes" [ngValue]="theme.value">{{ theme.label }}</option>
        </select>
      </label>
    </article>

    <article class="card">
      <h2>Notifications</h2>
      <p>Reçois les alertes de nouvelles recettes, commentaires et signalements.</p>

      <label class="toggle">
        <input
          type="checkbox"
          [ngModel]="notificationsEnabled"
          (ngModelChange)="setNotificationsEnabled($event === true)"
        />
        <span>Activer les notifications dans l’admin web</span>
      </label>

      <p class="permission">
        Permission navigateur: <strong>{{ notificationPermissionLabel() }}</strong>
      </p>

      <button
        type="button"
        class="ghost"
        (click)="requestBrowserPermission()"
        *ngIf="notificationPermission !== 'granted'"
      >
        Autoriser les notifications navigateur
      </button>
    </article>
  </div>
</section>
